import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApi } from '../services/api';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { data: notifData } = useApi(user ? '/notifications?unread=true' : null);
  const { data: msgData } = useApi(user ? '/messages' : null);
  const unreadMessageCount = (msgData?.conversations || []).reduce((sum, c) => sum + c.unread_count, 0);
  const unreadCount = (notifData?.unreadCount || 0) + unreadMessageCount;
  const { data: listingsData } = useApi(user ? '/listings/owner/mine' : null);
  const hasListings = (listingsData?.listings || []).length > 0;
  const [menuOpen, setMenuOpen] = useState(false);

  function closeMenu() { setMenuOpen(false); }

  function handleLogout() {
    closeMenu();
    logout();
    navigate('/');
  }

  const dashboardPath = hasListings ? '/dashboard/owner' : '/dashboard/buyer';

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <span className="navbar-brand-mark">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="7.5" r="3.4" fill="#FFD166" />
              <path d="M2.5 15c1.8-2.2 4-2.2 5.8 0s4 2.2 5.8 0 4-2.2 5.8 0" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" fill="none" />
              <path d="M2.5 19.2c1.8-2.2 4-2.2 5.8 0s4 2.2 5.8 0 4-2.2 5.8 0" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.65" />
            </svg>
          </span>
          ShareTime
        </Link>

        <button
          type="button"
          className="navbar-toggle"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(v => !v)}
        >
          <span className={`navbar-toggle-bars${menuOpen ? ' open' : ''}`}>
            <span></span><span></span><span></span>
          </span>
        </button>

        <div className={`navbar-links${menuOpen ? ' open' : ''}`}>
          <Link to="/search" onClick={closeMenu}>Search</Link>
          <Link to="/browse" onClick={closeMenu}>Browse</Link>

          {user ? (
            <>
              <Link to={dashboardPath} onClick={closeMenu}>
                Dashboard
                {unreadCount > 0 && (
                  <span style={{ marginLeft: '0.4rem', background: 'var(--danger)', color: 'var(--surface)', borderRadius: '999px', fontSize: 'var(--text-xs)', padding: '0.1rem 0.45rem', fontWeight: 700 }}>
                    {unreadCount}
                  </span>
                )}
              </Link>
              <button onClick={handleLogout} className="btn btn-outline btn-sm">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-outline btn-sm" onClick={closeMenu}>Log in</Link>
              <Link to="/register" className="btn btn-primary btn-sm" onClick={closeMenu}>Sign up</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
